import { UnifiedReservationDetails } from '@hkm/types/reservation/models/UnifiedReservationDetails';

export const getReservationBadgesCount = (
  reservation: UnifiedReservationDetails
): number => {
  return [reservation.isDayUse, reservation.isTimeGuaranteed].filter(Boolean)
    .length;
};



// WEBPACK FOOTER //
// ./src/components/shared/ReservationBadges/utils.ts